import React from 'react'
import { Row } from "react-bootstrap"
import CompanyFocusItem from "./CompanyFocusItem"

const focusItems = [
    { name: "categories" },
    { name: "subcategories" },
    { name: "platforms" },
    { name: "industries" },
]

const CompanyFocus = ({ data }) => {
    return (
        <div id="speciality" className="text-block border-bottom-0">
            <h2 className="h4 mb-4">Speciality</h2>
            <Row className="g-5">
                {focusItems.map((focus, index) => {
                    const focusName = focus.name
                    const focusData = data[focusName]

                    if (!focusData || Object.keys(focusData).length === 0) return null

                    return (
                        <CompanyFocusItem data={data} focusData={focusData} focusName={focusName} focusItems={focusItems} key={index} />
                    )
                })}
            </Row>
        </div >
    )
}

export default React.memo(CompanyFocus);
